import { render, staticRenderFns } from "./PaymentPlansPopUp.vue?vue&type=template&id=4e6d6edc&"
import script from "./PaymentPlansPopUp.vue?vue&type=script&lang=js&"
export * from "./PaymentPlansPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports